import React from 'react';

const Footer = () => {
	return (
		<>
			<footer className='w-100 py-3 bg-light text-center'>
				<p>
					© 2020{' '}
					<a href='https://dilkashshaikhmahajan.co.in/'>
						Dilkash Shaikh Mahajan
					</a>
					. All Rights Reserved | Terms and Conditions
				</p>
			</footer>
		</>
	);
};

export default Footer;
